import classNames from 'classnames/bind';

import { useUpdatePriceAlertNightConsent } from 'hooks/usePriceChangesSubscriptions';
import styles from '../index.module.scss';

const cx = classNames.bind(styles);

interface Props {
  onClose(): void;
}

export default function NightAlertConsent({ onClose }: Props) {
  const [updateConsent] = useUpdatePriceAlertNightConsent();

  function onCancel() {
    updateConsent({ variables: { isConsented: false }, onCompleted: onClose });
  }

  function onConfirm() {
    updateConsent({ variables: { isConsented: true }, onCompleted: onClose });
  }

  return (
    <div className={cx('SetNotificationAlert')}>
      <div className={cx('modal')}>
        <div className={cx('content')}>
          <h5 className={cx('title')}>
            야간 21:00~08:00에도
            <br />
            알림을 받으시겠어요?
          </h5>
          <p className={cx('text')}>
            야간 알림 수신 해제 방법
            <br />
            네이버 항공권 &gt; 가격알림 탭 &gt; 야간 알림 수신 해제
          </p>
          <div className={cx('btns')}>
            <button type="button" className={cx('cancel')} onClick={onCancel}>
              취소
            </button>
            <button type="button" className={cx('more')} onClick={onConfirm}>
              야간 수신 동의
            </button>
          </div>
          <button
            type="button"
            className={cx('close')}
            onClick={onCancel}
            aria-label="닫기"
          />
        </div>
      </div>
    </div>
  );
}
